import {
  CalendarEventResponse,
  CalendarEventId,
  CalendarEventRequest,
  CalendarEventScheduleRequest,
  CalendarEventScheduleResponse,
} from '@business/entities/calendar_event';
import { Endpoint } from '../endpoint';
import { CalendarTemplateId } from '@business/entities/calendar_template';
import { R } from '@core/utils/r';
import { AddEditCalendarTemplateEventFormData } from '@modules/settings/SettingsPage/Components/SchedulesTab/Tabs/ScheduleListTab/AddEditCalendartemplateEventV2Modal/CalendarTemplateEventForm';
import { CalendarTemplateEventResponse, CalendarTemplateEventOrderUpdateItem, DeleteCalendarTemplateEventResponse } from '@business/entities/calendar_template_event';

export function fetchEvents(data?: CalendarEventScheduleRequest) {
  const params = R.objectCompact(data);
  return Endpoint.get<CalendarTemplateEventResponse[]>(`@gc/calendar-template-events`, { params });
}

export function fetchCalendarTemplateEvents(id: CalendarTemplateId, request?: CalendarEventRequest) {
  return Endpoint.post<CalendarTemplateEventResponse[]>(`@gc/calendar-template-events/fetch/${id}`, { data: request });
}

export function createCalendarTemplateEvent(id: CalendarTemplateId, event: Partial<AddEditCalendarTemplateEventFormData>) {
  return Endpoint.post<CalendarTemplateEventResponse>(`@gc/calendar-template-events/${id}`, { data: event });
}

export function updateCalendarTemplateEvent(id: CalendarEventId, event: Partial<AddEditCalendarTemplateEventFormData>) {
  return Endpoint.patch<CalendarTemplateEventResponse>(`@gc/calendar-template-events/${id}`, { data: event });
}

export function quickUpdateCalendarTemplateEvent(
  id: CalendarEventId,
  changes: { offset?: number; duration?: number; startTime?: string; endTime?: string },
) {
  return Endpoint.post<CalendarTemplateEventResponse>(`@gc/calendar-template-events/quick-update/${id}`, { data: changes });
}

export function deleteCalendarTemplateEvent(eventId: CalendarEventId, cascade = false) {
  return Endpoint.delete<DeleteCalendarTemplateEventResponse>(`@gc/calendar-template-events/${eventId}${cascade ? '?cascade=1' : ''}`);
}

export function updateCalendarTemplateEventOrder(items: CalendarTemplateEventOrderUpdateItem[]) {
  return Endpoint.post<{ success: boolean }>('@gc/calendar-template-events/update-order', { data: { items } });
}
